import type { OptionsObject } from 'notistack';
import { SnackbarUtils } from '@/components/notification/snackbar';

const notify = (message: string, options: OptionsObject) => {
  SnackbarUtils.enqueue(message, options);
};

export const toast = {
  info: (message: string) => notify(message, { variant: 'info' }),
  success: (message: string) => notify(message, { variant: 'success' }),
  warning: (message: string) => notify(message, { variant: 'warning' }),
  error: (message: string) => notify(message, { variant: 'error' }),
  notify,
};
